import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";

import AuthUserChangePassword from '../../../services/helper/changeUserPassword';



const Changepassword = () => {
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [cnfPassword, setCnfPassword] = useState('')
  const { register, handleSubmit, formState: { errors } } = useForm();
  const form = useRef();
  const checkBtn = useRef();
  const navigate = useNavigate()
  const email = localStorage.getItem('username')
  const handleChangePassword = () => {
    if (cnfPassword === newPassword) {
      AuthUserChangePassword.changeUserPassword({
        email: JSON.parse(email),
        password: cnfPassword,
        currentpassword: password
      }).then((res) => {
        if (res.data.success === 0) {
          toast.error(res.data.error,
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
        } else {
          toast.success(res.data.response,
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            localStorage.setItem("last_login",res.data.lastlogin)
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
      })
    } else {
      toast.error('Confirm Password and New Password not same',
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
    }

  }

  return (
    <section>
      <div className="page-header section-height-75">
        <ToastContainer />
        <div className="container" style={{ paddingLeft: 'var(--bs-gutter-x, 1.6rem)' }}>
          <div className="row">
            <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto">
              <div className="card  mt-4">
                <div className="card-header pb-0 text-left bg-transparent ">
                  <h4 className="text-info text-gradient">
                    Change Password            </h4>
                </div>
                <div className="card-body">
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit(handleChangePassword)}
                    ref={form}
                  >
                    <label>Current Password</label>
                    <div className="mb-3">
                      <input
                        className="form-control  validate black-text"
                        name="Password"
                        type="Password"
                        placeholder='Password'
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    <label>New Password</label>
                    <div className="mb-3">
                      <input
                        className="form-control  validate black-text"
                        name="Password"
                        type="Password"
                        placeholder='Password'
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                    <label>Confirm Password</label>
                    <div className="mb-3">
                      <input
                        className="form-control"
                        name="password2"
                        type="password"
                        placeholder='Confirm Password'
                        onChange={(e) => setCnfPassword(e.target.value)}
                      />
                    </div>
                    <div className="text-center">
                      <button
                        type="submit"
                        name="submit"
                        className="btn bg-gradient-info w-100 mt-4 mb-0"
                      >
                        Submit
                      </button>
                    </div>
                    <CheckButton style={{ display: "none" }} ref={checkBtn}
                    />
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Changepassword